const AuthEndpoints = {
  register: {
    method: 'POST',
    url: () => '/auth/register',
  },
  login: {
    method: 'POST',
    url: () => '/auth/login',
  },
  logout: {
    method: 'POST',
    url: () => '/auth/logout',
  },
  getCustomToken: {
    method: 'GET',
    url: () => '/auth/get-custom-token',
  },
  authWithProvider: {
    method: 'POST',
    url: () => '/auth/auth-with-provider',
  },
  updateUser: {
    method: 'POST',
    url: () => '/auth/update-user',
  },
  deleteUser: {
    method: 'POST',
    url: () => '/auth/delete-user',
  },
  requestEmailChange: {
    method: 'POST',
    url: () => '/auth/request-email-change',
  },
  verifyEmailChange: {
    method: 'GET',
    url: () => '/auth/verify-email-change',
  },
  verificationCheck: {
    method: 'POST',
    url: () => '/v1/email-verification-check',
  },
  verificationSend: {
    method: 'POST',
    url: () => '/v1/email-verification-send',
  },
  verificationLoginSend: {
    method: 'POST',
    url: () => '/v1/email-verification-login-send',
  },
  verificationVerifyCode: {
    method: 'POST',
    url: () => '/v1/email-verification-verify-code',
  },
  verificationResendCode: {
    method: 'POST',
    url: () => '/v1/email-verification-resend-code',
  },
} as const;

// Create type from the object
type AuthEndpoints = typeof AuthEndpoints;

export type { AuthEndpoints };
export default AuthEndpoints;
